import styled from "styled-components";
import { theme as antdTheme } from "antd";
import type { GlobalToken } from "antd";
import { pageBleedCss } from "components/layout/pagePadding";
import { useLocation } from "react-router-dom";
import mainBg from "@/assets/images/main-background.png";
import homeBg from "@/assets/home-background.png";
import { ReactNode } from "react";
import { useProjectWizardStore } from "../../projects/useProjectWizardStore";

type BackgroundGroup = {
  paths: string[];
  image: string;
  condition?: boolean;
};

type Props = {
  children: ReactNode;
};

// Full-bleed: cancels the app shell's page padding so the image reaches the
// content area's edges (pages inside apply the padding themselves).
const Background = styled.div<{ $image: string; $token: GlobalToken }>`
  background-image: url(${({ $image }) => $image});
  background-size: cover;
  background-position: top left;
  ${({ $token }) => pageBleedCss($token)}
`;

export const BackgroundImage = ({ children }: Props) => {
  const { pathname } = useLocation();
  const { token } = antdTheme.useToken();
  const { hasNoProjects } = useProjectWizardStore();

  const groups: BackgroundGroup[] = [
    { paths: ["/home"], image: mainBg, condition: hasNoProjects },
    { paths: ["/home"], image: homeBg, condition: !hasNoProjects },
    {
      paths: [
        "/media/projects/prompt",
        "/media/projects/create",
        "/media/projects/document",
      ],
      image: mainBg,
    },
    {
      paths: ["/media/projects"],
      image: mainBg,
      condition: hasNoProjects,
    },
    {
      paths: ["/subscription/subscriptions"],
      image: mainBg,
    },
  ];

  const matchedGroup = groups.find(
    ({ paths, condition }) =>
      paths.includes(pathname) && (condition === undefined || condition)
  );

  if (!matchedGroup) return <>{children}</>;

  return (
    <Background $image={matchedGroup.image} $token={token}>
      {children}
    </Background>
  );
};
